import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import structuredClone from '@ungap/structured-clone';
import { Observable } from 'rxjs';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { SelfV2 } from 'src/app/core/alcmeon-context/models/self-v2.model';
import { SitesService } from 'src/app/mobile/shared/sites.service';
import { SiteV2 } from 'src/app/shared/models';
import { API_URL_COMPANIES } from 'src/app/shared/services/basic.service';
import { ErrorHandlingService } from 'src/app/shared/services/error-handling.service';
import { Task } from 'src/app/tasks/shared/models';

import { TaskListConfiguration } from '../../inbox/shared/models';
import { ChannelStockConfig, TodayCounter } from '../shared/models';
import { PushboxConfigurationService } from './pushbox-configuration.service';

@Injectable({
  providedIn: 'root',
})
export class PushboxService {
  private pushboxBaseUrl = `${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/push-mode`;
  private taskListConfig: TaskListConfiguration = null;
  private channelsTaskListConfigs: ChannelStockConfig[] = null;

  constructor(
    private alcmeonContextService: AlcmeonContextService,
    private errorHandlingService: ErrorHandlingService,
    private http: HttpClient,

    private pushboxConfigurationService: PushboxConfigurationService,
    private sitesService: SitesService
  ) {}

  /**
   * @returns use HttpResponse to be able to read the status code
   */
  getHighestPriorityTask(): Observable<HttpResponse<Task>> {
    return this.http
      .get<Task>(`${this.pushboxBaseUrl}/highest-priority-task`, {
        observe: 'response',
      })
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  getTodayCounters(): Observable<TodayCounter> {
    return this.http
      .get<TodayCounter>(`${this.pushboxBaseUrl}/today-counters`)
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  getStockCounters(data: ChannelStockConfig[]): Observable<ChannelStockConfig[]> {
    return this.http
      .post<ChannelStockConfig[]>(`${this.pushboxBaseUrl}/stock-counters`, data)
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  updateAvailableTaskListConfigs() {
    const sitesForConfigs: SiteV2[] = this.alcmeonContextService.getAllowedSites(this.sitesService.sitesV2Map);

    const siteIdsForConfigs: number[] = sitesForConfigs.map(site => site.id);
    const loggedUser: SelfV2 = this.alcmeonContextService.self;
    const routingTagsIds: number[] = loggedUser.routing_tags.map(el => el.id);

    this.taskListConfig = this.pushboxConfigurationService.getPushboxConfiguration(
      siteIdsForConfigs,
      routingTagsIds,
      loggedUser
    );

    this.channelsTaskListConfigs = this.pushboxConfigurationService.getChannelsConfiguration(sitesForConfigs);
  }

  getTaskListConfiguration(): TaskListConfiguration {
    return structuredClone(this.taskListConfig);
  }

  getAllChannelsTaskListConfigs(): ChannelStockConfig[] {
    return structuredClone(this.channelsTaskListConfigs);
  }
}
